/**
 * 顶栏全局校区切换器（总部范围用户的校区口径唯一入口）。
 *
 * 渲染门控：权限快照就绪且 hasAllOrgScope === true 才渲染——快照未就绪（含加载中/
 * 拉取失败置 null）与非总部范围一律不渲染（防闪烁误渲染，SC-09/SC-10）。
 * 选项 = 「全部校区」+ ACTIVE 校区（label 为校区名称，showSearch 按名称过滤）；
 * 选择即更新全局范围并持久化（SC-13），页面经 GlobalCampusContext 即时联动。
 */
import { Select } from 'antd';
import { useSession } from '../auth/SessionContext';
import { useGlobalCampusScope } from '../auth/GlobalCampusContext';
import type { GlobalCampusScope } from '../auth/global-campus-storage';

/** 全局校区切换器（AdminLayout Header 内渲染，位于标题与铃铛之间）。 */
export function GlobalCampusSwitcher() {
  const { permissions } = useSession();
  const { scope, setScope, campuses } = useGlobalCampusScope();

  // 权限快照未就绪（null，含加载中与拉取失败）或非总部范围：不渲染（SC-09/SC-10）
  if (!permissions || permissions.hasAllOrgScope !== true) return null;

  return (
    <Select<GlobalCampusScope>
      value={scope}
      onChange={setScope}
      showSearch
      optionFilterProp="label"
      style={{ width: 168 }}
      options={[
        { value: 'ALL', label: '全部校区' },
        ...campuses.map((c) => ({ value: c.id, label: c.name })),
      ]}
    />
  );
}
